<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">E-coupon Report</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row">
      <div class="col-md-3" v-if="role == userRoleAdmin || role == userRoleSuperAdmin">
        <div class="form-group">
          <label>Merchant</label>
          <select class="form-control" v-model="merchant">
            <option value>All</option>
            <option
              v-for="item in merchants"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2 fit-content">
        <div class="form-group">
          <label>Start Date</label>
          <input type="date" class="form-control" v-model="startDate" />
        </div>
      </div>
      <div class="col-md-2 fit-content">
        <div class="form-group">
          <label>End Date</label>
          <input type="date" class="form-control" v-model="endDate" />
        </div>
      </div>

      <div class="col-md-2 fit-content">
        <div class="form-group">
          <label>Status</label>
          <select
            class="form-control"
            v-model="status">
            <option value="">All</option>
            <option :value="ecouponStatusActive">
              {{ ecouponStatusActive }}
            </option>
            <option :value="ecouponStatusIssued">
              {{ ecouponStatusIssued }}
            </option>
            <option :value="ecouponStatusRedeemed">
              {{ ecouponStatusRedeemed }}
            </option>
            <option :value="ecouponStatusCancelled">
              {{ ecouponStatusCancelled }}
            </option>
            <option :value="ecouponStatusVoided">
              {{ ecouponStatusVoided }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-2">
        <button class="btn btn-primary filter-btn" @click="getReport">
          Search
        </button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->

    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>Merchant</th>
                <th>E-coupon Code</th>
                <th>Package Details</th>
                <th v-if="merchantAfterSearch == ''">Addon Date</th>
                <th v-else>{{ merchantAddonDateLabel }}</th>
                <th v-if="statusAfterSearch == ''">Status</th>
                <th>Issued Date</th>
                <th>Redeemed Date</th>
                <th v-if="statusAfterSearch == '' || statusAfterSearch == ecouponStatusCancelled">Cancelled Date</th>
                <th v-if="statusAfterSearch == '' || statusAfterSearch == ecouponStatusVoided">Voided Date</th>
                <th>Hotel Confirmation</th>
                <th>Reservation ID</th>
                <th>Unit Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="ecoupons && ecoupons.length > 0" v-for="(ecoupon, i) in ecoupons" :key="i">
                <td>{{ ecoupon.merchantName }}</td>
                <td>{{ ecoupon.code }}</td>
                <td>{{ ecoupon.additionalInfo ? ecoupon.additionalInfo.addon_name : '-' }}</td>
                <td>{{ ecoupon.additionalInfo ? ecoupon.additionalInfo.addon_date : '-' }}</td>
                <td v-if="statusAfterSearch == ''">{{ ecoupon.status }}</td>
                <td>{{ ecoupon.issuedDate ? ecoupon.issuedDate : '-' }}</td>
                <td>{{ ecoupon.redeemedDate ? ecoupon.redeemedDate : '-' }}</td>
                <td v-if="statusAfterSearch == '' || statusAfterSearch == ecouponStatusCancelled">{{ ecoupon.cancelledDate ? ecoupon.cancelledDate : '-' }}</td>
                <td v-if="statusAfterSearch == '' || statusAfterSearch == ecouponStatusVoided">{{ ecoupon.voidedDate ? ecoupon.voidedDate : '-' }}</td>
                <td>{{ ecoupon.booking_confirmation_no ? ecoupon.booking_confirmation_no : '-' }}</td>
                <td>{{ ecoupon.booking_id ? ecoupon.booking_id : '-' }}</td>
                <td>{{ ecoupon.additionalInfo ? ecoupon.additionalInfo.addon_price : '-' }}</td>
              </tr>
              <tr v-if="ecoupons && !ecoupons.length">
                <td v-if="statusAfterSearch == ''" colspan="12" class="text-center">
                  {{ noRecordText }}
                </td>
                <td v-else colspan="10" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="ecoupons && ecoupons.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          ecoupons.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />
          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- Redeemed Customer Modal -->
    <div class="modal custom-modal fade" id="redemptionDetail" role="dialog">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">{{ redemptionDetail.code }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
              <table class="table table-bordered custom-table mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Date of Birth</th>
                    <th>Gender</th>
                    <th>Redemption Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(customer, i) in redemptionDetail.redeemedCustomers"
                    :key="i"
                  >
                    <td>{{ customer.name }}</td>
                    <td>{{ customer.email }}</td>
                    <td>{{ customer.dob }}</td>
                    <td>{{ customer.gender }}</td>
                    <td>{{ customer.redemptionDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Redeemed Customer Modal -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import $ from "jquery";
export default {
  data() {
    return {
      userRoleSuperAdmin: config.USER_ROLE_SUPER_ADMIN,
      userRoleAdmin: config.USER_ROLE_ADMIN,
      userRoleMerchantAdmin: config.USER_ROLE_MERCHANT_ADMIN,
      userRoleMerchantUser: config.USER_ROLE_MERCHANT_USER,
      noRecordText: config.NO_RECORD_TEXT,
      ecouponStatusActive: config.ECOUPON_STATUS_ACTIVE,
      ecouponStatusIssued: config.ECOUPON_STATUS_ISSUED,
      ecouponStatusRedeemed: config.ECOUPON_STATUS_REDEEMED,
      ecouponStatusDeleted: config.ECOUPON_STATUS_DELETED,
      ecouponStatusCancelled: config.ECOUPON_STATUS_CANCELLED,
      ecouponStatusVoided: config.ECOUPON_STATUS_VOIDED,
      ecoupons: [],
      redemptionDetail: { code: "", redeemedCustomers: [] },
      //pagination
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
      //filter
      merchant: "",
      merchantAddonDateLabel: "",
      merchantAfterSearch: "",
      merchants: [],
      code: "",
      startDate: moment().format("YYYY-MM-01"),
      endDate: moment().format("YYYY-MM-DD"),
      discountType: "",
      distributionChannel: "",
      status: "",
      statusAfterSearch: "",
      isMerchantsLoaded: false,
      isInitialReportLoaded: false,

    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data.role;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
  },
  watch: {
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    showRedemptionDetail(code) {
      this.redemptionDetail.code = code;
      this.redemptionDetail.redeemedCustomers = this.ecoupons.find(
        (c) => c.code == code
      ).redeemedCustomers;
      $("#redemptionDetail").modal("show");
    },
    getReport() {
      this.$store.state.isLoading = true;
      this.statusAfterSearch = this.status;

      let params = {
        start_date: this.startDate,
        end_date: this.endDate,
        current_page: this.paging.CurrentPage,
        total_page: this.paging.TotalPage,
        size_per_page: this.paging.SizePerPage,
        status: this.status
      };

      if ( this.merchant ) {
        params.merchant_id = this.merchant;
        this.merchantAddonDateLabel = this.merchants.find(merchant => merchant.id == this.merchant).addon_date_label;
        this.merchantAfterSearch = this.merchant;
      }
      else {
        this.merchantAddonDateLabel = "Addon Date";
        this.merchantAfterSearch = "";
      }

      API.getEcouponReport(params, this.config)
        .then((response) => {
          if (response.data.success) {
            let numberOfRecords = response.data.total_records ? response.data.total_records : response.data.records.length;
            this.ecoupons = response.data.records;
            this.isInitialReportLoaded = true;

            if ( numberOfRecords > 0 ) {
              this.paging.TotalPage = Math.ceil(numberOfRecords / this.paging.SizePerPage);
            }
            else {
              this.paging.TotalPage = 1;
            }

            this.totalRecords = numberOfRecords;
            

            /*for ( const outerKey in data ) {
              for ( const innerKey in data[outerKey] ) {
                this.ecoupons.push(data[outerKey][innerKey]);
              }
            }*/

            //this.totalRecords = this.ecoupons.length;

            //console.log(this.ecoupons);
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }

          if ( this.isInitialReportLoaded && this.isMerchantsLoaded ) {
            this.$store.state.isLoading = false;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });

      /*this.ecoupons = [
        {
          merchant: "Burger King",
          code: "BK-001",
          startDate: "1 January 2025",
          expiryDate: "31 December 2025",
          discountType: "Percentage Discount",
          discountAmount: "30%",
          totalGenerated: 10,
          totalRedeemed: 5,
          totalNotRedeemed: 5,
          status: "Active",
          redeemedCustomers: [
            {
              name: "Andy",
              email: "andy@gmail.com",
              dob: "20 January 1988",
              gender: "Male",
              redemptionDate: "5/12/2024 10:59:25",
            },
            {
              name: "Alan",
              email: "alan@gmail.com",
              dob: "19 March 1985",
              gender: "Male",
              redemptionDate: "4/12/2024 11:14:22",
            },
            {
              name: "Susy",
              email: "susy@outlook.com",
              dob: "19 April 1988",
              gender: "Female",
              redemptionDate: "3/12/2024 10:04:22",
            },
            {
              name: "Susan",
              email: "susan@gmail.com",
              dob: "2 August 1988",
              gender: "Female",
              redemptionDate: "2/12/2024 10:04:22",
            },
            {
              name: "Garry",
              email: "garry@yahoo.com",
              dob: "4 October 1988",
              gender: "Male",
              redemptionDate: "1/12/2024 9:04:22",
            },
          ],
        },
        {
          merchant: "KFC",
          code: "KFC-XA9D1",
          startDate: "1 January 2025",
          expiryDate: "31 January 2025",
          discountType: "Amount Discount",
          discountAmount: "$20",
          totalGenerated: 1,
          totalRedeemed: 1,
          totalNotRedeemed: 0,
          status: "Active",
          redeemedCustomers: [
            {
              name: "Garry",
              email: "garry@yahoo.com",
              dob: "4 October 1988",
              gender: "Male",
              redemptionDate: "12/12/2024 9:05:21",
            },
          ],
        },
        {
          merchant: "McDonald's",
          code: "MCD-1242",
          startDate: "1 April 2024",
          expiryDate: "2 April 2024",
          discountType: "Amount Discount",
          discountAmount: "$25",
          totalGenerated: 2,
          totalRedeemed: 0,
          totalNotRedeemed: 2,
          status: "Expired",
          redeemedCustomers: [],
        },
        {
          merchant: "Pizza Hut",
          code: "PHT-1242",
          startDate: "1 May 2025",
          expiryDate: "2 May 2025",
          discountType: "Percentage Discount",
          discountAmount: "25%",
          distributionChannel: "Email",
          totalGenerated: 4,
          totalRedeemed: 1,
          totalNotRedeemed: 3,
          status: "Active",
          redeemedCustomers: [
            {
              name: "Michael",
              email: "michael@yahoo.com",
              dob: "1 May 1978",
              gender: "Male",
              redemptionDate: "11/12/2025 19:04:22",
            },
          ],
        },
      ];
      this.totalRecords = this.ecoupons.length;
      this.paging.TotalPage = 1;
      if (this.paging.CurrentPage > this.paging.TotalPage) {
        this.paging.CurrentPage = 1;
      }*/
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getReport();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getReport();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      console.log(this.paging.CurrentPage);
      this.getReport();
    },
    next() {
      this.paging.CurrentPage += 1;
      console.log(this.paging.CurrentPage);
      this.getReport();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getReport();
    },
    getMerchants() {
      this.$store.state.isLoading = true;
      API.getAllMerchants({}, this.config)
        .then((response) => {
          if (response.data.success) {
            this.merchants = response.data.records;
            console.log(this.merchants);
            this.isMerchantsLoaded = true;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }

          if ( this.isInitialReportLoaded && this.isMerchantsLoaded ) {
            this.$store.state.isLoading = false;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
  },
  created() {
    this.getMerchants();
    this.getReport();
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Share/EcouponUsageReport.vue